export default "__VITE_ASSET__yta11A9M__"